
import { Button, Modal, Icon } from 'ant-design-vue';
import {
  Component, Vue, Prop, Emit,
} from 'vue-property-decorator';

interface ManageObject {
  name: string;
  telephone: number;
}

@Component({
  components: {
    AModal: Modal,
    AIcon: Icon,
    AButton: Button,
  },
})
export default class ManageDialog extends Vue {
  @Prop({ default: false }) readonly visible!: boolean;

  @Prop({ default: '创建班级、账号续费、开通教师角色请联系以下管理员' })
  readonly title!: string;

  private manageList: ManageObject[] = [];

  @Emit('update:visible')
  private handleCancel() {
    return false;
  }

  // 获取管理员列表
  private getAdminList() {
    this.$service.common.getAdminList().then((data: []) => {
      this.manageList = data.splice(0, 3);
    });
  }

  private mounted() {
    this.getAdminList();
  }
}
